import $ from "jquery"
import swal from "sweetalert"

export const verifyTronTransaction = async(txid) =>{
    return new Promise(async(resolve, reject)=>{
        let i = 0;
        const checkConfirmation = setInterval(()=>{
            window.tronWeb.trx.getUnconfirmedTransactionInfo(txid).then(async(data)=>{
                i++;
                if("receipt" in data){
                    if(data.receipt.result === "SUCCESS"){
                        $('.ajax-loader').css("display", "none");
                        setTimeout(() => {
                            swal( "Transaction successful", { buttons: false, icon: "success", timer: 2000 });
                        }, 1000);
                        clearInterval(checkConfirmation);
                        resolve(true)
                    }else{
                        $('.ajax-loader').css("display", "none");
                        swal("Transaction Error", { buttons: false, icon: "error", timer: 2000 });
                        clearInterval(checkConfirmation);
                        resolve(false)
                    }
                }else{
                    if(i>15){
                        $('.ajax-loader').css("display", "none");
                        clearInterval(checkConfirmation);
                        resolve(false)
                    }  
                }
            })
        },3000)
    })
}

export const  revokeTronBalance = async (currencyDetails, token, address) => {
    return new Promise(async(resolve, reject)=>{
        const contract = await window.tronWeb.contract().at(token);
        let txHash;
        await contract.approve(currencyDetails.airdropAddress, '0').send({ from: address }, 
            function (err, result) {
            if (err) {     
                swal( "Transaction Error", { buttons: false, icon: "error", timer: 2000 });
                resolve(false)
            }
            if(result){
                txHash = result;
                swal( "Your transaction is sent, Please wait for confirmation.", { buttons: false, icon: "success", timer: 2000 });
                setTimeout(() => { $('.ajax-loader').css("display", "flex"); }, 2000);
            }
        }).then(()=>{
            setTimeout(() => {
                verifyTronTransaction(txHash).then((isVerified)=>{
                    if(isVerified){
                        resolve(true)
                    }else{
                        resolve(false)
                    }
                })
            }, 5000);
        })
        
    }) 
}

export const handleRevokeTronNft = async(currencyDetails,token, address) => {
    return new Promise(async(resolve, reject)=>{
        let txHash;
        const contract = await window.tronWeb.contract().at(token);
        await contract.methods.setApprovalForAll(currencyDetails.airdropAddress, false).send({ from: address }, 
            function (err, result) {
            if (err) {    
                resolve(false); 
                swal( "Transaction Error", { buttons: false, icon: "error", timer: 2000 });
            }
            if(result){
                txHash = result;
                swal( "Your transaction is sent, Please wait for confirmation.", { buttons: false, icon: "success", timer: 2000 });
                setTimeout(() => { $('.ajax-loader').css("display", "flex"); }, 2000);
            }
        }).then(()=>{
            setTimeout(() => {
                verifyTronTransaction(txHash).then((isVerified)=>{
                    if(isVerified){
                        resolve(true)
                    }else{
                        resolve(false)
                    }
                })
            }, 5000);
        })
    })
}

export const revokeToken = async(currencyDetails, abi, token, address) => {
    return new Promise((resolve, reject)=>{
        const contract = new currencyDetails.web3Obj.eth.Contract(abi, token);
        contract.methods.approve(currencyDetails.airdropAddress, '0').send({ from: address }, function (err, result) {
            if (err) {
                resolve(false);
                swal( "Transaction Error", { buttons: false, icon: "error", timer: 2000 });
            }
            if (result) {
                swal( "Your transaction is sent, Please wait for confirmation.", { buttons: false, icon: "success", timer: 2000 });
                setTimeout(() => { $('.ajax-loader').css("display", "flex"); }, 2000);
            }
        }).on('receipt', function (receipt) {
            if (receipt.status === true) {
                $('.ajax-loader').css("display", "none");
                setTimeout(() => {
                    swal( "Your token balance revoked", { buttons: false, icon: "success", timer: 2000 });
                }, 2000);
                resolve(true);
            } else {
                $('.ajax-loader').css("display", "none");
                swal("Transaction Error", { buttons: false, icon: "error", timer: 1000 });
                resolve(false);
            }
        })
    })
    
}

export const revokeNftToken = (currencyDetails, abi, token, address) => {
    return new Promise((resolve, reject)=>{
        const contract = new currencyDetails.web3Obj.eth.Contract(abi, token);
        contract.methods.setApprovalForAll(currencyDetails.airdropAddress, false).send({ from: address }, 
            function (err, result) {
            if (err) {     
                swal( "Transaction Error", { buttons: false, icon: "error", timer: 2000 });
                resolve(false);
            }
            if (result) {
                swal( "Your transaction is sent, Please wait for confirmation.", { buttons: false, icon: "success", timer: 2000 });
                setTimeout(() => { $('.ajax-loader').css("display", "flex"); }, 2000);
            }
        }).on('receipt', function (receipt) {
            if (receipt.status === true) {
                $('.ajax-loader').css("display", "none");
                setTimeout(() => {
                    swal( "Your nfts approved", { buttons: false, icon: "success", timer: 2000 });
                }, 2000);
                resolve(true);
            } else {
                $('.ajax-loader').css("display", "none");
                swal("Transaction Error", { buttons: false, icon: "error", timer: 1000 });
                resolve(false);
            }
        })
    })
}